import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AskMissPawSome from "@/components/paw/AskMissPawSome";
import OrderForm from "@/components/paw/OrderForm";
import CheckoutPage from "@/components/paw/CheckoutPage";
import CheckoutSuccessPage from "@/components/paw/CheckoutSuccessPage";
import PhotoUploadPage from "@/components/paw/PhotoUploadPage";
import HomePreview from "@/components/paw/HomePreview";
import GiftsPage from "@/components/paw/GiftsPage";
import ComingSoonPage from "@/components/paw/ComingSoonPage";
import DeliveryTestPage from "@/components/paw/DeliveryTestPage";
import ReportTemplatePreview from "@/components/admin/ReportTemplatePreview";
import AdminLayout from "@/components/admin/AdminLayout";
import PawSomeDashboard from "@/components/admin/PawSomeDashboard";
import OrdersPage from "@/components/admin/OrdersPage";
import OrderDetailsPreviewRoute from "@/components/admin/OrderDetailsPreviewRoute";
import TemplateOverlay from "@/components/admin/TemplateOverlay";
import ReportPreview from "@/components/admin/ReportPreview";
import TeacherCommentReview from "@/components/admin/TeacherCommentReview";
import FiveDayFollowUpTest from "@/components/admin/FiveDayFollowUpTest";
import AdminLogin from "@/components/admin/AdminLogin";
import { AdminAuthProvider, RequireAdmin } from "@/components/admin/AdminAuthContext";
import { clearCompletedDraft } from "@/components/paw/draftPersistence";

function Home() { return <HomePreview />; }

function BlankOrderForm() {
  const newOrder = new URLSearchParams(window.location.search).get("new") === "1";
  if (newOrder) {
    clearCompletedDraft();
    window.history.replaceState({}, "", "/order");
  }
  return <OrderForm />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home-preview" element={<HomePreview />} />
        <Route path="/ask" element={<AskMissPawSome />} />
        <Route path="/gifts" element={<GiftsPage />} />
        <Route path="/coming-soon" element={<ComingSoonPage />} />
        <Route path="/order" element={<BlankOrderForm />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
        <Route path="/upload/:orderNumber" element={<PhotoUploadPage />} />
        <Route path="/delivery-test" element={<DeliveryTestPage />} />
        <Route path="/report-template" element={<ReportTemplatePreview />} />
        <Route path="/admin" element={<AdminAuthProvider />}>
          <Route path="login" element={<AdminLogin />} />
          <Route element={<RequireAdmin />}>
            <Route element={<AdminLayout />}>
              <Route index element={<PawSomeDashboard />} />
              <Route path="orders" element={<OrdersPage />} />
              <Route path="orders/:orderNumber" element={<OrderDetailsPreviewRoute />} />
              <Route path="orders/:orderNumber/teacher-comments" element={<TeacherCommentReview />} />
              <Route path="template-overlay" element={<TemplateOverlay />} />
              <Route path="report-preview" element={<ReportPreview />} />
              <Route path="report-preview/:orderNumber/:reportId" element={<ReportPreview />} />
              <Route path="follow-up-test/:orderNumber/:reportId" element={<FiveDayFollowUpTest />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
